import { navigateToUrl } from 'single-spa';
import manifest from '../../public/manifest.json';
import { portalShellManager } from './PortalShell';
const appsWithoutRedirect = ['@uipath/portal', '@uipath/global-app'];
export const PR_PREVIEW_REDIRECT_KEY = '__pr_preview_redirectAfterLogin__';
// PR previews are only allowed on alpha (and local development).
// Keep in sync with the `import-map-overrides-domains` allowlist in index.ejs.
const PR_PREVIEW_HOSTNAMES = ['localhost', 'alpha.uipath.com', 'portal.alpha.uipath.com'];
// PR preview bundles are only served from the single-spa PR preview container.
const PR_PREVIEW_ORIGIN = 'https://singlespadev.uipath-dev.com';
const PR_PREVIEW_PATH_PREFIX = '/single-spa-test/pr-preview/';
function isPrPreviewEnabled() {
    // import-map-overrides does not define its API on hosts outside its domain allowlist
    return PR_PREVIEW_HOSTNAMES.includes(window.location.hostname) && !!window.importMapOverrides;
}
function getAllowedPreviewUrl(path) {
    if (typeof path !== 'string') {
        return undefined;
    }
    try {
        // URL normalizes dot segments, so the prefix check cannot be bypassed with `../`
        const url = new URL(path);
        if (url.origin !== PR_PREVIEW_ORIGIN ||
            url.username ||
            url.password ||
            !url.pathname.startsWith(PR_PREVIEW_PATH_PREFIX)) {
            return undefined;
        }
        return url.href;
    }
    catch (_a) {
        return undefined;
    }
}
function parseModule(module) {
    var _a;
    try {
        const { name, path } = (_a = JSON.parse(module)) !== null && _a !== void 0 ? _a : {};
        const url = getAllowedPreviewUrl(path);
        if (typeof name !== 'string' || !Object.keys(manifest).includes(name) || !url) {
            return undefined;
        }
        return { name, url };
    }
    catch (_b) {
        return undefined;
    }
}
export function setOverrides() {
    const importMapOverrides = window.importMapOverrides;
    if (!isPrPreviewEnabled() || !importMapOverrides) {
        localStorage.removeItem(PR_PREVIEW_REDIRECT_KEY);
        return;
    }
    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;
    if (searchParams.get('spa-reset')) {
        importMapOverrides.resetOverrides();
        localStorage.removeItem('devtools');
    }
    searchParams.getAll('spa-module').forEach(module => {
        const parsedModule = parseModule(module);
        if (!parsedModule) {
            console.error('Ignoring invalid spa-module override:', module);
            return;
        }
        const { name, url } = parsedModule;
        if (!appsWithoutRedirect.includes(name)) {
            localStorage.setItem(PR_PREVIEW_REDIRECT_KEY, name);
        }
        importMapOverrides.addOverride(name, url);
        localStorage.setItem('devtools', 'true');
    });
}
export function redirectToPreview() {
    if (!isPrPreviewEnabled()) {
        return;
    }
    const portalShell = portalShellManager.getPortalShell();
    const shouldRedirectTo = localStorage.getItem(PR_PREVIEW_REDIRECT_KEY);
    if (portalShell && shouldRedirectTo) {
        if (manifest[shouldRedirectTo]) {
            const { activeWhen } = manifest[shouldRedirectTo];
            const orgName = activeWhen.includes(':accountId') ? portalShellManager.getOrganizationName() + '/' : '';
            const tenantName = activeWhen.includes(':tenantId') ? portalShellManager.getTenantName() + '/' : '';
            const serviceName = shouldRedirectTo.split('/')[1] + '_';
            navigateToUrl(`/${orgName}${tenantName}${serviceName}`);
            localStorage.removeItem(PR_PREVIEW_REDIRECT_KEY);
        }
    }
}
